import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=528110c2&"
import script from "./RegisterForm.vue?vue&type=script&lang=js&"
export * from "./RegisterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ageo\\Documents\\Work\\fhapplication\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('528110c2')) {
      api.createRecord('528110c2', component.options)
    } else {
      api.reload('528110c2', component.options)
    }
    module.hot.accept("./RegisterForm.vue?vue&type=template&id=528110c2&", function () {
      api.rerender('528110c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/auth/components/RegisterForm.vue"
export default component.exports